import {
    UPDATE_PASSWORD,
    UPDATE_PASSWORD_SUCCESS,
    UPDATE_PASSWORD_FAILURE,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILURE
} from "../Constants";

const init = {
    data: {},
};

const UpdatePasswordReducer = (state = init, action) => {
    switch (action.type) {
        case UPDATE_PASSWORD:
            return { ...state, loading: true };
        case UPDATE_PASSWORD_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case UPDATE_PASSWORD_FAILURE:
            return { ...state, loading: false, data: action.payload };
        case RESET_PASSWORD:
            return { ...state, loading: true };
        case RESET_PASSWORD_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case RESET_PASSWORD_FAILURE:
            return { ...state, loading: false, data: action.payload };
        default:
            return state;
    }
};

export default UpdatePasswordReducer;